import * as actionTypes from "./types";

const initialState = {
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.PAGE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.PAGE_LOADED:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
